<template>
    <app-sercheable-data-table :headers="headers" :search="search" :refresh="refresh">
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn :to="{ name: 'typeApproverCreate' }" color="primary">{{ $t('label.createTypeApprover') }}</v-btn>
        </template>

        <template slot="items" slot-scope="{item}">
            <router-link :to="{ name: 'typeApproverEdit', params: { id: item.id }}" tag="tr">
                <td>{{ item.name }}</td>
                <td class="is-active">{{ item.status }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
// import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../../shared/SercheableDataTable';

export default {
    data() {
        return {
            headers: [
                {
                    text: this.$t('label.name'),
                    value: 'name',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: `${this.$t('label.active')}?`,
                    value: 'status',
                    align: 'left',
                },
            ],
        };
    },

    computed: {
        approverTypes() {
            const types = this.$store.getters.approverTypes.filter(item => item.name !== 'SOLICITANTE');
            types.forEach((type) => { type.status = type.isActive ? this.$t('label.yes') : this.$t('label.no'); });
            return types;
        },
        readonly() {
            return !this.$store.getters.isAdmin;
        },
    },

    components: {
        appSercheableDataTable: SercheableDataTable,
    },

    methods: {
        search(filters) {
            return utilities.filterMultiple(this.approverTypes, filters, (type, regex) => (
                regex.test(type.name) ||
                regex.test(type.status)
            ));
        },
        async refresh() {
            await this.$store.dispatch('loadApproverTypes');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/types/approver/Index.vue